import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { getBooleanBody, getObjectsTableBasicBody } from "../../tablesShared/tableTools/tableCellBodies"
import { tableBooleanEnums } from "../tableFeatures/tableEnums"
import { getOptionsRowFilterTemplate } from "../tableFeatures/tableTemplates/tableFilterTemplates"
import { getCustomTableEnumBody } from "../tableFeatures/tableTemplates/tableCellTemplates"
import { getItemWebStorage } from "../../../features/webStorageSaver"
import { defaultBodyTemplate } from "../tableFeatures/tableTemplates/tableBodyTemplates/default"

type TableWidget = {
    tableValue: any,
    columns: any,
    tableState?: any,
    onRowSelect?: any,
    dataCount?: any,
    tableClassName?: any,
    paginatorTemplate?: any,
    selectionMode?: any,
    selection?: any,
    headerColumnGroup?: any,
    onSelectionChange?: any,
    pageSize?: any,
    onPage?: any,
    onSort?: any,
    onFilter?: any,
    canBeFiltered?: boolean,
    canBeSorted?: boolean,
    type?: any,
    rowClassName?: any,
    rowIsSelectable?: boolean,
    isLazy?: boolean,
    withButtonsRow?: boolean,
    withTitleRow?: boolean
}

export default function TableWidget({ tableValue, tableState, columns, onRowSelect, headerColumnGroup: headerColumnGroup, dataCount, tableClassName, paginatorTemplate, selectionMode, selection, onSelectionChange,
    pageSize, onPage, onSort, onFilter, canBeFiltered: tableCanBeFiltered = true, canBeSorted: tableCanBeSorted = true, type, rowClassName, rowIsSelectable, isLazy,
    withButtonsRow, withTitleRow }: TableWidget) {

    const paginatorRelatedTableStyle = (dataCount > pageSize ? ' with-paginator' : ' without-paginator');
    const buttonsRowRelatedTableStyle = withButtonsRow ? ' with-buttons-row' : '';
    const titleRowRelatedTableStyle = withTitleRow ? ' with-title-row' : '';
    const tableStyle = tableClassName ?? '';
    return (
        <>
            <DataTable
                className={tableStyle + paginatorRelatedTableStyle + buttonsRowRelatedTableStyle + titleRowRelatedTableStyle}
                value={tableValue}
                scrollable
                size="small"
                removableSort
                selectionMode={selectionMode ?? "single"}
                selection={selection}
                onSelectionChange={onSelectionChange}
                onRowSelect={onRowSelect}
                dataKey="$InfoObjectID"
                paginator={dataCount > 0}
                alwaysShowPaginator={false}
                rows={pageSize}
                paginatorTemplate={paginatorTemplate}
                currentPageReportTemplate="{first}-{last} из {totalRecords}"
                filterDisplay={tableCanBeFiltered ? "row" : undefined}
                emptyMessage="Данных нет"
                lazy={isLazy}
                first={tableState?.first ?? 0}
                totalRecords={dataCount}
                onPage={onPage}
                headerColumnGroup={headerColumnGroup}
                onSort={onSort}
                sortField={tableState?.sortField}
                sortOrder={tableState?.sortOrder}
                onFilter={onFilter}
                filters={tableState?.filters}
                isDataSelectable={rowIsSelectable}
                rowClassName={rowClassName}
            >
                {/* Столбцы таблицы */}
                {columns?.map((column: any, index: any) => {
                    let { body: bodyOptions, bodyTemplate, field, filterSelectValues, enumObjectStorageKey, enumObject, bodyImageSrc, showFilterMenu,
                        filterPlaceholder, canBeSorted, canBeFiltered, headerName, headerTemplate, valueType, align, valueFormat, selectionMode, textWrap } = column ?? {}
                    let body = (rowData: any) => defaultBodyTemplate(rowData, field, valueFormat)
                    if (bodyOptions) {
                        body = (rowData: any) => bodyOptions(rowData, field);
                    } else if (bodyTemplate) {
                        body = (rowData: any) => bodyTemplate(rowData, field);
                    } else {
                        if (tableBooleanEnums[field]) {
                            body = (rowData: any) => getBooleanBody(rowData, field)
                        }
                        if (filterSelectValues && type === 'custom') {
                            const customTablesEnums = getItemWebStorage('customTablesEnums') ?? {}
                            const enumObject = customTablesEnums?.[enumObjectStorageKey]
                            body = (rowData: any) => getCustomTableEnumBody(rowData, field, enumObject)
                        }
                        if (enumObject) {
                            body = (rowData: any) => getCustomTableEnumBody(rowData, field, enumObject)
                        }
                    }
                    return (
                        <Column
                            key={`${field}-${index}`}
                            field={field}
                            showFilterMenu={showFilterMenu}
                            filter={tableCanBeFiltered && canBeFiltered}
                            filterElement={filterSelectValues ? (options) => getOptionsRowFilterTemplate(options, filterPlaceholder, filterSelectValues, enumObject) : undefined}
                            filterPlaceholder={filterPlaceholder}
                            sortable={tableCanBeSorted && canBeSorted}
                            header={headerTemplate ?? headerName}
                            body={body}
                            align={bodyImageSrc ? "center" : tableBooleanEnums[field] !== undefined ? "center" : (align || 'right')}
                            alignHeader="center"
                            dataType={(valueType === "float" || valueType === "int" || valueType === "date") ? "numeric" : undefined}
                            selectionMode={selectionMode}
                            bodyStyle={textWrap ? undefined : { textWrap: "nowrap" }}
                        >
                        </Column>
                    )
                })}
            </DataTable>
        </>
    )
}
